// ==============================
// Imports
// ==============================

// MUI Components
import AppBarSpacer from '../components/common/AppBarSpacer';
import { Button } from '@mui/material';
import { HowToReg } from '@mui/icons-material';
import PageHeader from '../components/common/PageHeader';

// Libraries
import { useState } from 'react';
import { useTranslation } from '../i18n';

// Local components
import MiniDrawer from '../components/MiniDrawer';
import RegistrationTable from '../components/RegistrationTable';
import RegistrationImportButton from '../components/Registration/RegistrationImportButton';
import QuickActions from '../components/QuickActions';

const RegistrationLayout = () => {
  // States
  const [open, setOpen] = useState(true);
  const { t } = useTranslation();

  // ==============================
  // Render
  // ==============================
  return (
    <>
      <div className="flex h-screen">
        {/* Sidebar */}
        <MiniDrawer open={open} setOpen={setOpen} />

        {/* Main content */}
        <main className="flex-1 overflow-auto app-page-bg">
          {/* Offset for fixed AppBar (height = 64px) */}
          <AppBarSpacer />

          <div className="h-full px-6 py-4">
            <PageHeader
              title={t('registration.title')}
              subtitle={t('registration.subtitle')}
            />
            {/* Action buttons — below the divider */}
            <QuickActions>
              {(handlers) => (
                <div className="flex justify-end gap-4 mb-4">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<HowToReg />}
                    onClick={handlers.openExistedUser}
                    className="bg-blue-600 hover:bg-blue-700 !text-white font-semibold py-2 px-4 rounded"
                  >
                    {t('registration.enroll')}
                  </Button>
                  <RegistrationImportButton />
                </div>
              )}
            </QuickActions>
            {/* Registration table */}
            <RegistrationTable />
          </div>
        </main>
      </div>
    </>
  );
};

export default RegistrationLayout;
